import { refreshDownloadUrl } from "../api/media";

/**
 * Opens a document URL in a new tab.
 *
 * Handles three cases:
 * 1. Public URL (no X-Amz-) → open directly (never expires)
 * 2. Expired presigned URL (has X-Amz-) → extract key, get fresh URL
 * 3. Raw object key (no http) → get a fresh presigned URL
 */
export async function openDocument(scanValue: string): Promise<void> {
  if (!scanValue) return;

  try {
    if (scanValue.startsWith("http") && !scanValue.includes("X-Amz-")) {
      // Public URL — open directly, never expires
      window.open(scanValue, "_blank");
    } else if (scanValue.startsWith("http") && scanValue.includes("X-Amz-")) {
      // Legacy presigned URL — extract key and refresh
      const key = extractKeyFromUrl(scanValue);
      const freshUrl = await refreshDownloadUrl(key, 604800);
      window.open(freshUrl, "_blank");
    } else {
      // Raw object key — get a presigned URL
      const freshUrl = await refreshDownloadUrl(scanValue, 604800);
      window.open(freshUrl, "_blank");
    }
  } catch {
    // Last resort: try the original value
    window.open(scanValue, "_blank");
  }
}

/**
 * Extract the object key from a MinIO URL.
 * URL: https://storage.codenekt.com/codenekt/u-1234/strongbox/file.jpg?X-Amz-...
 * Key: u-1234/strongbox/file.jpg
 */
function extractKeyFromUrl(url: string): string {
  try {
    const pathname = new URL(url).pathname;
    return pathname.replace(/^\/codenekt\//, "").replace(/^\//, "");
  } catch {
    return url;
  }
}
